// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header{
    height: 65px;
    display: flex;
    align-items: center;
}

.header2{
    height: 120px;
    display: flex;
    align-items: center;
}

h1{
    display: flex;
    justify-content: center;
}
  
.dynamic-box{
    background-color: #dbd5cd87; 
    padding: 50px; 
    margin-left: 200px;
    margin-right: 200px;
    min-height: max-content;
    min-width: max-content;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
}

.form{
    display: flex;
    justify-content: center;
    text-align: center;
    flex-direction: column;
    align-items: center;
    max-width: 100px;
}

p{
    display: flex;
    justify-content: center;
    color: #9f9c97;
}

input[type="text"]::placeholder {
    text-align: center;
    font-size: 14px;
    font-weight: 400;
}

input[type="text"] {
    margin-top: 15px;
    margin-bottom: 15px; 
    width: 500px;
    height: 50px;
    flex-shrink: 0;
    border: 4px solid #dbd5cd;
    background: #FFF;
    font-size: 14px;
    font-weight: 400;
    text-align: center;
}

.button-submit-update {
    appearance: none;
    background-color: white;
    border: 3px solid #dbd5cd;
    border-radius: 5px;
    box-sizing: border-box;
    color: #9f9c97;
    display: inline-block;
    margin: 10px 50px;
    font-family: Roobert,-apple-system,BlinkMacSystemFont,"Segoe UI",Helvetica,Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol";
    font-size: 14px;
    font-weight: 400;
    line-height: normal;
    min-width: 100px !important;
    max-width: 100px !important;
    height: 50px; 
    line-height: 15px;
    padding: 10px;
    outline: none;
    padding: 16px 24px;
    text-align: center !important;
    text-decoration: none;
    transition: all 300ms cubic-bezier(.23, 1, 0.32, 1);
    user-select: none;
    -webkit-user-select: none;
    touch-action: manipulation;
    will-change: transform;
    align-self: flex-end; /* Align the button to the bottom of its container */
    margin-left: auto !important;
    margin-right: auto !important;
  }
  
.button-submit-update:disabled {
    pointer-events: none;
}
  
.button-submit-update:hover {
    color: #9f9c97;
    background-color: #fff;
    box-shadow: rgba(0, 0, 0, 0.25) 0 8px 15px;
    transform: translateY(-2px);
}
  
.button-submit-update:active {
    box-shadow: none;
    transform: translateY(0);
}


.notification {
    position: relative;
    padding: 10px;
    background-color: #f0f0f0;
    border: 1px solid #ccc;
    border-radius: 4px;
    margin-top: 100px;
  }
  
  .close-button {
    position: absolute;
    top: 5px;
    right: 5px;
    background: none;
    border: none;
    cursor: pointer;
    font-size: 14px;
    color: #888;
  }`, "",{"version":3,"sources":["webpack://./src/pages/style/Update.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,2BAA2B;IAC3B,aAAa;IACb,kBAAkB;IAClB,mBAAmB;IACnB,uBAAuB;IACvB,sBAAsB;IACtB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,kBAAkB;IAClB,sBAAsB;IACtB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,cAAc;IACd,yBAAyB;IACzB,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,uBAAuB;IACvB,yBAAyB;IACzB,kBAAkB;IAClB,sBAAsB;IACtB,cAAc;IACd,qBAAqB;IACrB,iBAAiB;IACjB,kJAAkJ;IAClJ,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,2BAA2B;IAC3B,2BAA2B;IAC3B,YAAY;IACZ,iBAAiB;IACjB,aAAa;IACb,aAAa;IACb,kBAAkB;IAClB,6BAA6B;IAC7B,qBAAqB;IACrB,mDAAmD;IACnD,iBAAiB;IACjB,yBAAyB;IACzB,0BAA0B;IAC1B,sBAAsB;IACtB,oBAAoB,EAAE,oDAAoD;IAC1E,4BAA4B;IAC5B,6BAA6B;EAC/B;;AAEF;IACI,oBAAoB;AACxB;;AAEA;IACI,cAAc;IACd,sBAAsB;IACtB,0CAA0C;IAC1C,2BAA2B;AAC/B;;AAEA;IACI,gBAAgB;IAChB,wBAAwB;AAC5B;;;AAGA;IACI,kBAAkB;IAClB,aAAa;IACb,yBAAyB;IACzB,sBAAsB;IACtB,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,eAAe;IACf,WAAW;EACb","sourcesContent":[".header{\n    height: 65px;\n    display: flex;\n    align-items: center;\n}\n\n.header2{\n    height: 120px;\n    display: flex;\n    align-items: center;\n}\n\nh1{\n    display: flex;\n    justify-content: center;\n}\n  \n.dynamic-box{\n    background-color: #dbd5cd87; \n    padding: 50px; \n    margin-left: 200px;\n    margin-right: 200px;\n    min-height: max-content;\n    min-width: max-content;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    flex-direction: column;\n}\n\n.form{\n    display: flex;\n    justify-content: center;\n    text-align: center;\n    flex-direction: column;\n    align-items: center;\n    max-width: 100px;\n}\n\np{\n    display: flex;\n    justify-content: center;\n    color: #9f9c97;\n}\n\ninput[type=\"text\"]::placeholder {\n    text-align: center;\n    font-size: 14px;\n    font-weight: 400;\n}\n\ninput[type=\"text\"] {\n    margin-top: 15px;\n    margin-bottom: 15px; \n    width: 500px;\n    height: 50px;\n    flex-shrink: 0;\n    border: 4px solid #dbd5cd;\n    background: #FFF;\n    font-size: 14px;\n    font-weight: 400;\n    text-align: center;\n}\n\n.button-submit-update {\n    appearance: none;\n    background-color: white;\n    border: 3px solid #dbd5cd;\n    border-radius: 5px;\n    box-sizing: border-box;\n    color: #9f9c97;\n    display: inline-block;\n    margin: 10px 50px;\n    font-family: Roobert,-apple-system,BlinkMacSystemFont,\"Segoe UI\",Helvetica,Arial,sans-serif,\"Apple Color Emoji\",\"Segoe UI Emoji\",\"Segoe UI Symbol\";\n    font-size: 14px;\n    font-weight: 400;\n    line-height: normal;\n    min-width: 100px !important;\n    max-width: 100px !important;\n    height: 50px; \n    line-height: 15px;\n    padding: 10px;\n    outline: none;\n    padding: 16px 24px;\n    text-align: center !important;\n    text-decoration: none;\n    transition: all 300ms cubic-bezier(.23, 1, 0.32, 1);\n    user-select: none;\n    -webkit-user-select: none;\n    touch-action: manipulation;\n    will-change: transform;\n    align-self: flex-end; /* Align the button to the bottom of its container */\n    margin-left: auto !important;\n    margin-right: auto !important;\n  }\n  \n.button-submit-update:disabled {\n    pointer-events: none;\n}\n  \n.button-submit-update:hover {\n    color: #9f9c97;\n    background-color: #fff;\n    box-shadow: rgba(0, 0, 0, 0.25) 0 8px 15px;\n    transform: translateY(-2px);\n}\n  \n.button-submit-update:active {\n    box-shadow: none;\n    transform: translateY(0);\n}\n\n\n.notification {\n    position: relative;\n    padding: 10px;\n    background-color: #f0f0f0;\n    border: 1px solid #ccc;\n    border-radius: 4px;\n    margin-top: 100px;\n  }\n  \n  .close-button {\n    position: absolute;\n    top: 5px;\n    right: 5px;\n    background: none;\n    border: none;\n    cursor: pointer;\n    font-size: 14px;\n    color: #888;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
